import { api_get, api_post } from "./utils"

const CallAPI = {
    getToken: _getToken,
    createCall: _createCall,
    addParticipant: _addParticipant,
    removeParticipant: _removeParticipant,
    fetchParticipants: _fetchParticipants,
    fetchByAssociation: _fetchByAssociation
};


async function _getToken(identityKey: string) {

    if (!identityKey) {
        return null;
    }
    return api_get("/call/token?identity=" + identityKey).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

async function _createCall(numberTo="", associated_type="", associated_uuid="", identityKey="") {
    const body = {
        number_to: numberTo,
        associated_type: associated_type,
        associated_uuid: associated_uuid,
        identity: identityKey
    };
    console.log("body: %o", body);
    return api_post("/call/create", body).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}



async function _addParticipant(numberTo="", callKey="", identityKey="") {
    const body = {
        number_to: numberTo,
        call: callKey,
        identity: identityKey
    };
    return api_post("/call/add-participant", body).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

async function _removeParticipant(callKey="", callSid="", identityKey="") {
    const body = {
        twilio_call_sid: callSid,
        call: callKey,
        identity: identityKey
    };
    return api_post("/call/remove-participant", body).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}



async function _fetchParticipants(callKey="", identityKey="", cursor="") {
    const url = `/call/participants?call=${callKey}&identity=${identityKey}&cursor=${cursor}`;
    return api_get(url)
        .then((res) => {
            if (!res.ok) {
                return null;
            }
            else {
                return res.json();
            }
        });
}

async function _fetchByAssociation(associated_type="", associated_uuid="", identity="", cursor="") {

    const params = { associated_type, associated_uuid, identity, cursor };
    return api_get("/call/by-association", params)
        .then((res) => {
            if (!res.ok) {
                return null;
            }
        else {
            return res.json();
        }
        });
}

export default CallAPI;
